export default __webpack_public_path__ + "static/article-christmas-gift-ideas-for-the-whole-family-c8f1f2d8e9b5f09cd6d514c8efdb62a7.jpg";